(() => {
  if (window.soflySocialSignupLoaded) return;
  window.soflySocialSignupLoaded = true;
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-social-club-signup]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]'), status = form.querySelector('[data-club-signup-status]');
    if (button.disabled) return;
    button.disabled = true; button.setAttribute('aria-busy', 'true'); status.textContent = 'Requesting your confirmation email…';
    try {
      const response = await fetch('https://marketing.sofly.io/api/social-club/signup', {method: 'POST', credentials: 'omit', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({email: form.elements.email.value, website: form.elements.website.value}), signal: AbortSignal.timeout(30000)});
      const result = await response.json();
      if (!response.ok) throw new Error(result.message || 'We couldn’t request your email. Please try again shortly.');
      status.textContent = result.message;
      form.reset();
    } catch (error) {
      status.textContent = error.message && error.name !== 'TimeoutError' && error.name !== 'TypeError' ? error.message : 'We couldn’t confirm the request. Check your inbox before trying again.';
    } finally {button.disabled = false; button.removeAttribute('aria-busy');}
  });
})();
